export const ADDRESSES_PATH = '/myaccount/addresses';
